import React, { Component } from "react";
import {
  MDBDataTable,
  MDBTableHead,
  MDBTableBody,
  MDBTable,
  MDBBtn,
} from "mdbreact";
import {
  AvInput,
  Card,
  CardBody,
  Col,
  Form,
  Row,
  FormGroup,
  Label,
  Input,
  CustomInput,
  Button,
  Modal,
  Container,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import {
  createRoomHospitalityService,
  updateRoomHospitalityService,
  getroomHospitalityServiceId,
  getRoomHospitalityServiceList,
  removeRoomHospitalityService,
} from "../../Endpoint/Admin/index";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { toast } from "react-toastify";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";

import { AvForm, AvField } from "availity-reactstrap-validation";

class FormElements extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invalidFile: false,
      previewImage: undefined,
      items: [],
      isLoaded: false,
      updatemodal: false,
      modal: false,
      hospitalityServiceName: "",
      roomHospitalityServiceId: null,
      selectedFile: null, // to store selected file
      handleResponse: null, // handle the API response
      imageUrl: null, // to store uploaded image path
      invalidImage: null,
      selectedFileName: "",

      success: {},
      breadcrumbItems: [
        { title: "", link: "#" },
        { title: " ", link: "#" },
      ],
      customchk: true,
      toggleSwitch: true,
      tableData: {
        columns: [
          {
            label: "Hospitality Service Name",
            field: "hospitalityServiceName",
            sort: "asc",
            width: 60,
          },
          {
            label: "Room Hospitality ServiceIcon",
            field: "icon",
            sort: "asc",
            width: 150,
          },

          {
            label: "Update",
            field: "update",
            sort: "asc",
            width: 100,
          },

          {
            label: "Remove",
            field: "remove",
            sort: "asc",
            width: 100,
          },
        ],
        rows: [],
      },
    };
    this.reader = new FileReader();
    this.handleChange = this.handleChange.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggle = this.toggle.bind(this);
    this.getALlluser = this.getALlluser.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }
  toggle() {
    this.setState({
      modal: !this.state.modal,
      hospitalityServiceName: "",
      roomHospitalityServiceId: "",
      previewImage: "",
      invalidImage: "",
      selectedOption: null,
    });
  }
  updatetoggle() {
    this.setState({
      updatemodal: !this.state.updatemodal,
    });
  }

  handleCloseModal() {
    this.setState({
      updatemodal: false,
      modal: false,
    });
  }

  onFileChange(event) {
    const imageFile = event.target.files[0];

    if (!imageFile.name.match(/\.(jpg|jpeg|png)$/)) {
      this.setState({
        invalidImage: "Please select valid image.",
        previewImage: URL.createObjectURL(event.target.files[0]),
      });
      return false;
    } else {
      this.setState({
        selectedFile: event.target.files[0],
        previewImage: URL.createObjectURL(event.target.files[0]),
        invalidImage: null,
      });
    }
  }

  handleChange = (e) => {
    this.setState(
      {
        [e.target.id]: e.target.value,
      },
      () => {}
    );
  };

  handleSubmit(e) {
    e.preventDefault();

    const formData = new FormData();
    formData.append(
      "hospitalityServiceName",
      this.state.hospitalityServiceName
    );
    formData.append("roomHospitalityServiceIcon", this.state.selectedFile);
    formData.append(
      "roomHospitalityServiceId",
      this.state.roomHospitalityServiceId
    );

    if (
      this.state.roomHospitalityServiceId == "" ||
      this.state.roomHospitalityServiceId == null
    ) {
      createRoomHospitalityService(formData)
        .then((response) => {
          if (response.status !== 200) {
            toast.error(response.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: response.status === 200,
                message: "success",
                hospitalityServiceName: "",
                selectedFile: null, // to store selected file
                handleResponse: null, // handle the API response
                imageUrl: null, // to store uploaded image path
                invalidImage: null,
                selectedFileName: "",
                previewImage: "",
                roomHospitalityServiceId: "",
              },
            });
            this.getALlluser();

            this.handleCloseModal();

            toast.success("Room Hospitality Service added successfully");
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    } else {
      updateRoomHospitalityService(formData)
        .then((updateResults) => {
          if (updateResults.status !== 200) {
            toast.error(updateResults.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: updateResults.status === 200,
                message: "success",
                roomHospitalityServiceId: "",
              },
            });
            this.getALlluser();

            this.handleCloseModal();

            toast.success("Room Hospitality Service updated successfully");
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    }
  }

  getALlluser() {
    getRoomHospitalityServiceList().then((result) => {
      this.setState({
        isLoaded: true,
        items: result.data,
        tableData: {
          ...this.state.tableData,
          rows: result.data,
          list: result.data.map((x) => {
            x.update = (
              <button
                className="btn btn-primary"
                onClick={() => this.editHospitalservice(x._id.toString(), x)}
              >
                Update
              </button>
            );
            x.remove = (
              <button
                className="btn btn-danger"
                onClick={() => this.removeHospitalService(x._id.toString())}
              >
                Remove
              </button>
            );
            x.icon = <img src={x.icon} width="50" height="50" />;
            return x;
          }),
        },
      });
    });
  }

  componentDidMount() {
    this.getALlluser();
  }

  editHospitalservice(id) {
    getroomHospitalityServiceId(id)
      .then((results) => {
        this.setState({
          hospitalityServiceName: results.data.hospitalityServiceName,
          previewImage: results.data.icon,
          selectedFile: results.data.iconFile,
          roomHospitalityServiceId: results.data._id,
        });
      })
      .catch((error) => {
        toast.error("error");
      });
    this.toggle();
  }

  removeHospitalService(id) {
    removeRoomHospitalityService(id)
      .then((results) => {
        this.getALlluser();
      })
      .catch((error) => {
        toast.error("error");
      });
  }

  render() {
    const { handleResponse, invalidImage, items, previewImage } = this.state;

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title=""
              breadcrumbItems={this.state.breadcrumbItems}
            />

            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody>
                    <Button color="primary" onClick={this.toggle}>
                      Add Room Hospitality Service
                    </Button>
                    <Modal
                      isOpen={this.state.modal}
                      toggle={this.toggle}
                      className={this.props.className}
                    >
                      <ModalHeader toggle={this.toggle}>
                        RoomHospitalityService Details
                      </ModalHeader>
                      <ModalBody>
                        <AvForm onValidSubmit={this.handleSubmit}>
                          <Row form>
                            <Col md={12}>
                              <FormGroup>
                                <Label for="email">
                                  Hospitality ServiceName
                                </Label>
                                <AvField
                                  type="text"
                                  value={this.state.hospitalityServiceName}
                                  onChange={this.handleChange}
                                  id="hospitalityServiceName"
                                  name="hospitalityServiceName"
                                  required
                                />
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row form>
                            <Col md={10}>
                              <Label
                                htmlFor="example-number-input"
                                className="col-md- col-form-label"
                              >
                                Room Hospitality Service Icon{" "}
                              </Label>

                              <div className="custom-file">
                                <AvField
                                  tag={CustomInput}
                                  name="file"
                                  id="file"
                                  type="file"
                                  accept="image/*"
                                  onChange={this.onFileChange}
                                />
                                <Label
                                  className="custom-file-label"
                                  htmlFor="customFile"
                                >
                                  Choose file
                                </Label>
                              </div>
                              {previewImage && (
                                <div>
                                  <img
                                    style={{
                                      borderRadius: "50%",
                                      width: 80,
                                      height: 80,
                                      // background: "red",
                                      display: "block",
                                    }}
                                    className="img-fluid"
                                    src={previewImage}
                                    alt=""
                                  />
                                </div>
                              )}
                            </Col>
                          </Row>

                          <div className="text-center mt-4">
                            {invalidImage && (
                              <p className="error">{invalidImage}</p>
                            )}
                            <span> {this.state.selectedFileName}</span>
                            {handleResponse && (
                              <p
                                className={
                                  handleResponse.isSuccess ? "success" : "error"
                                }
                              >
                                {handleResponse.message}
                              </p>
                            )}
                            <Button color="primary" size="sm">
                              Submit
                            </Button>{" "}
                          </div>
                        </AvForm>
                      </ModalBody>
                    </Modal>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Breadcrumbs
              title="Data Tables"
              breadcrumbItems={this.state.breadcrumbItems}
            />

            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody>
                    <h4 className="card-title">
                      Room Hospitality Service Datatable{" "}
                    </h4>
                    <p className="card-title-desc"></p>

                    <MDBDataTable
                      responsive
                      bordered
                      data={this.state.tableData}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default FormElements;
